// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"mainContainer_mainContainer__Vp8Ae","contentContainer":"mainContainer_contentContainer__3j7jm"};